import * as React from 'react';

import { PageTitleBar } from 'components';

const SpecialOfferHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { SpecialOfferHeader };
